var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 31,
    viewBox: "0 0 50 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.6606 1.9987C35.7344 -0.527526 23.2839 4.83113 23.6011 12.3333C23.7598 17.1561 27.9628 21.5195 33.1174 19.223C39.303 16.8498 37.5583 4.44837 48.6606 2.07525V1.9987Z",
    stroke: "#5A5A5A",
    strokeWidth: 2,
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8756 5.29077C30.7384 9.11837 28.1214 14.477 27.3284 19.0701",
    stroke: "#5A5A5A",
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0793 23.9691C6.23396 16.0843 15.6709 12.4864 19.5568 16.5436C22.0944 19.1463 22.3323 23.4332 18.4465 24.9642C13.847 26.8015 7.89931 19.6056 1 23.8925L1.0793 23.9691Z",
    stroke: "#5A5A5A",
    strokeWidth: 2,
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85095 20.1418C14.1642 19.1467 18.3672 19.9887 21.3014 21.8258",
    stroke: "#5A5A5A",
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3014 21.8256C23.8391 23.127 25.0286 24.1222 26.6939 26.1891C26.6939 23.127 26.8526 21.1366 27.3284 18.8401M23.046 29.8636C26.2181 26.1891 27.9628 25.2705 33.3553 22.9739L23.046 29.8636Z",
    stroke: "#5A5A5A",
    strokeWidth: 2,
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.6edcf035bdda90bf9592e1d5a5958e7f.svg";
export { ForwardRef as ReactComponent };